/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as FileUploadRouteImport } from './routes/file-upload'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedTestRouteImport } from './routes/_authenticated/test'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthenticatedAdminRouteRouteImport } from './routes/_authenticated/admin/route'
import { Route as AuthenticatedDealsIndexRouteImport } from './routes/_authenticated/deals/index'
import { Route as AuthenticatedCustomersIndexRouteImport } from './routes/_authenticated/customers/index'
import { Route as AuthenticatedSchedulerDateRouteImport } from './routes/_authenticated/scheduler/$date'
import { Route as AuthenticatedDealsNewRouteImport } from './routes/_authenticated/deals/new'
import { Route as AuthenticatedDealsDealIdRouteImport } from './routes/_authenticated/deals/$dealId'
import { Route as AuthenticatedCustomersCustomerIdRouteImport } from './routes/_authenticated/customers/$customerId'
import { Route as AuthenticatedAccountingUploadIncomingSkvDocumentsRouteImport } from './routes/_authenticated/accounting/upload-incoming-skv-documents'
import { Route as AuthenticatedAccountingRutQuestionsRouteImport } from './routes/_authenticated/accounting/rut-questions'
import { Route as AuthenticatedAdminUsersIndexRouteImport } from './routes/_authenticated/admin/users/index'
import { Route as AuthenticatedAdminTablesIndexRouteImport } from './routes/_authenticated/admin/tables/index'

const FileUploadRoute = FileUploadRouteImport.update({
  id: '/file-upload',
  path: '/file-upload',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedTestRoute = AuthenticatedTestRouteImport.update({
  id: '/test',
  path: '/test',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthenticatedAdminRouteRoute = AuthenticatedAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedDealsIndexRoute = AuthenticatedDealsIndexRouteImport.update({
  id: '/deals/',
  path: '/deals/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedCustomersIndexRoute =
  AuthenticatedCustomersIndexRouteImport.update({
    id: '/customers/',
    path: '/customers/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSchedulerDateRoute =
  AuthenticatedSchedulerDateRouteImport.update({
    id: '/scheduler/$date',
    path: '/scheduler/$date',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDealsNewRoute = AuthenticatedDealsNewRouteImport.update({
  id: '/deals/new',
  path: '/deals/new',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedDealsDealIdRoute =
  AuthenticatedDealsDealIdRouteImport.update({
    id: '/deals/$dealId',
    path: '/deals/$dealId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCustomersCustomerIdRoute =
  AuthenticatedCustomersCustomerIdRouteImport.update({
    id: '/customers/$customerId',
    path: '/customers/$customerId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAccountingUploadIncomingSkvDocumentsRoute =
  AuthenticatedAccountingUploadIncomingSkvDocumentsRouteImport.update({
    id: '/accounting/upload-incoming-skv-documents',
    path: '/accounting/upload-incoming-skv-documents',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAccountingRutQuestionsRoute =
  AuthenticatedAccountingRutQuestionsRouteImport.update({
    id: '/accounting/rut-questions',
    path: '/accounting/rut-questions',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminUsersIndexRoute =
  AuthenticatedAdminUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminTablesIndexRoute =
  AuthenticatedAdminTablesIndexRouteImport.update({
    id: '/tables/',
    path: '/tables/',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/file-upload': typeof FileUploadRoute
  '/admin': typeof AuthenticatedAdminRouteRouteWithChildren
  '/login': typeof AuthLoginRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/test': typeof AuthenticatedTestRoute
  '/accounting/rut-questions': typeof AuthenticatedAccountingRutQuestionsRoute
  '/accounting/upload-incoming-skv-documents': typeof AuthenticatedAccountingUploadIncomingSkvDocumentsRoute
  '/customers/$customerId': typeof AuthenticatedCustomersCustomerIdRoute
  '/deals/$dealId': typeof AuthenticatedDealsDealIdRoute
  '/deals/new': typeof AuthenticatedDealsNewRoute
  '/scheduler/$date': typeof AuthenticatedSchedulerDateRoute
  '/customers/': typeof AuthenticatedCustomersIndexRoute
  '/deals/': typeof AuthenticatedDealsIndexRoute
  '/admin/tables/': typeof AuthenticatedAdminTablesIndexRoute
  '/admin/users/': typeof AuthenticatedAdminUsersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/file-upload': typeof FileUploadRoute
  '/admin': typeof AuthenticatedAdminRouteRouteWithChildren
  '/login': typeof AuthLoginRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/test': typeof AuthenticatedTestRoute
  '/accounting/rut-questions': typeof AuthenticatedAccountingRutQuestionsRoute
  '/accounting/upload-incoming-skv-documents': typeof AuthenticatedAccountingUploadIncomingSkvDocumentsRoute
  '/customers/$customerId': typeof AuthenticatedCustomersCustomerIdRoute
  '/deals/$dealId': typeof AuthenticatedDealsDealIdRoute
  '/deals/new': typeof AuthenticatedDealsNewRoute
  '/scheduler/$date': typeof AuthenticatedSchedulerDateRoute
  '/customers': typeof AuthenticatedCustomersIndexRoute
  '/deals': typeof AuthenticatedDealsIndexRoute
  '/admin/tables': typeof AuthenticatedAdminTablesIndexRoute
  '/admin/users': typeof AuthenticatedAdminUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/file-upload': typeof FileUploadRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRouteRouteWithChildren
  '/_auth/login': typeof AuthLoginRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/profile': typeof AuthenticatedProfileRoute
  '/_authenticated/test': typeof AuthenticatedTestRoute
  '/_authenticated/accounting/rut-questions': typeof AuthenticatedAccountingRutQuestionsRoute
  '/_authenticated/accounting/upload-incoming-skv-documents': typeof AuthenticatedAccountingUploadIncomingSkvDocumentsRoute
  '/_authenticated/customers/$customerId': typeof AuthenticatedCustomersCustomerIdRoute
  '/_authenticated/deals/$dealId': typeof AuthenticatedDealsDealIdRoute
  '/_authenticated/deals/new': typeof AuthenticatedDealsNewRoute
  '/_authenticated/scheduler/$date': typeof AuthenticatedSchedulerDateRoute
  '/_authenticated/customers/': typeof AuthenticatedCustomersIndexRoute
  '/_authenticated/deals/': typeof AuthenticatedDealsIndexRoute
  '/_authenticated/admin/tables/': typeof AuthenticatedAdminTablesIndexRoute
  '/_authenticated/admin/users/': typeof AuthenticatedAdminUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/file-upload'
    | '/admin'
    | '/login'
    | '/dashboard'
    | '/profile'
    | '/test'
    | '/accounting/rut-questions'
    | '/accounting/upload-incoming-skv-documents'
    | '/customers/$customerId'
    | '/deals/$dealId'
    | '/deals/new'
    | '/scheduler/$date'
    | '/customers/'
    | '/deals/'
    | '/admin/tables/'
    | '/admin/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/file-upload'
    | '/admin'
    | '/login'
    | '/dashboard'
    | '/profile'
    | '/test'
    | '/accounting/rut-questions'
    | '/accounting/upload-incoming-skv-documents'
    | '/customers/$customerId'
    | '/deals/$dealId'
    | '/deals/new'
    | '/scheduler/$date'
    | '/customers'
    | '/deals'
    | '/admin/tables'
    | '/admin/users'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_authenticated'
    | '/file-upload'
    | '/_authenticated/admin'
    | '/_auth/login'
    | '/_authenticated/dashboard'
    | '/_authenticated/profile'
    | '/_authenticated/test'
    | '/_authenticated/accounting/rut-questions'
    | '/_authenticated/accounting/upload-incoming-skv-documents'
    | '/_authenticated/customers/$customerId'
    | '/_authenticated/deals/$dealId'
    | '/_authenticated/deals/new'
    | '/_authenticated/scheduler/$date'
    | '/_authenticated/customers/'
    | '/_authenticated/deals/'
    | '/_authenticated/admin/tables/'
    | '/_authenticated/admin/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  FileUploadRoute: typeof FileUploadRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/file-upload': {
      id: '/file-upload'
      path: '/file-upload'
      fullPath: '/file-upload'
      preLoaderRoute: typeof FileUploadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/test': {
      id: '/_authenticated/test'
      path: '/test'
      fullPath: '/test'
      preLoaderRoute: typeof AuthenticatedTestRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/deals/': {
      id: '/_authenticated/deals/'
      path: '/deals'
      fullPath: '/deals/'
      preLoaderRoute: typeof AuthenticatedDealsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/customers/': {
      id: '/_authenticated/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AuthenticatedCustomersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/scheduler/$date': {
      id: '/_authenticated/scheduler/$date'
      path: '/scheduler/$date'
      fullPath: '/scheduler/$date'
      preLoaderRoute: typeof AuthenticatedSchedulerDateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/deals/new': {
      id: '/_authenticated/deals/new'
      path: '/deals/new'
      fullPath: '/deals/new'
      preLoaderRoute: typeof AuthenticatedDealsNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/deals/$dealId': {
      id: '/_authenticated/deals/$dealId'
      path: '/deals/$dealId'
      fullPath: '/deals/$dealId'
      preLoaderRoute: typeof AuthenticatedDealsDealIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/customers/$customerId': {
      id: '/_authenticated/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof AuthenticatedCustomersCustomerIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/accounting/upload-incoming-skv-documents': {
      id: '/_authenticated/accounting/upload-incoming-skv-documents'
      path: '/accounting/upload-incoming-skv-documents'
      fullPath: '/accounting/upload-incoming-skv-documents'
      preLoaderRoute: typeof AuthenticatedAccountingUploadIncomingSkvDocumentsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/accounting/rut-questions': {
      id: '/_authenticated/accounting/rut-questions'
      path: '/accounting/rut-questions'
      fullPath: '/accounting/rut-questions'
      preLoaderRoute: typeof AuthenticatedAccountingRutQuestionsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/users/': {
      id: '/_authenticated/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AuthenticatedAdminUsersIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/tables/': {
      id: '/_authenticated/admin/tables/'
      path: '/tables'
      fullPath: '/admin/tables/'
      preLoaderRoute: typeof AuthenticatedAdminTablesIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
  }
}

interface AuthRouteRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface AuthenticatedAdminRouteRouteChildren {
  AuthenticatedAdminTablesIndexRoute: typeof AuthenticatedAdminTablesIndexRoute
  AuthenticatedAdminUsersIndexRoute: typeof AuthenticatedAdminUsersIndexRoute
}

const AuthenticatedAdminRouteRouteChildren: AuthenticatedAdminRouteRouteChildren =
  {
    AuthenticatedAdminTablesIndexRoute: AuthenticatedAdminTablesIndexRoute,
    AuthenticatedAdminUsersIndexRoute: AuthenticatedAdminUsersIndexRoute,
  }

const AuthenticatedAdminRouteRouteWithChildren =
  AuthenticatedAdminRouteRoute._addFileChildren(
    AuthenticatedAdminRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAdminRouteRoute: typeof AuthenticatedAdminRouteRouteWithChildren
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedTestRoute: typeof AuthenticatedTestRoute
  AuthenticatedAccountingRutQuestionsRoute: typeof AuthenticatedAccountingRutQuestionsRoute
  AuthenticatedAccountingUploadIncomingSkvDocumentsRoute: typeof AuthenticatedAccountingUploadIncomingSkvDocumentsRoute
  AuthenticatedCustomersCustomerIdRoute: typeof AuthenticatedCustomersCustomerIdRoute
  AuthenticatedDealsDealIdRoute: typeof AuthenticatedDealsDealIdRoute
  AuthenticatedDealsNewRoute: typeof AuthenticatedDealsNewRoute
  AuthenticatedSchedulerDateRoute: typeof AuthenticatedSchedulerDateRoute
  AuthenticatedCustomersIndexRoute: typeof AuthenticatedCustomersIndexRoute
  AuthenticatedDealsIndexRoute: typeof AuthenticatedDealsIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRouteRoute: AuthenticatedAdminRouteRouteWithChildren,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedTestRoute: AuthenticatedTestRoute,
  AuthenticatedAccountingRutQuestionsRoute:
    AuthenticatedAccountingRutQuestionsRoute,
  AuthenticatedAccountingUploadIncomingSkvDocumentsRoute:
    AuthenticatedAccountingUploadIncomingSkvDocumentsRoute,
  AuthenticatedCustomersCustomerIdRoute: AuthenticatedCustomersCustomerIdRoute,
  AuthenticatedDealsDealIdRoute: AuthenticatedDealsDealIdRoute,
  AuthenticatedDealsNewRoute: AuthenticatedDealsNewRoute,
  AuthenticatedSchedulerDateRoute: AuthenticatedSchedulerDateRoute,
  AuthenticatedCustomersIndexRoute: AuthenticatedCustomersIndexRoute,
  AuthenticatedDealsIndexRoute: AuthenticatedDealsIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  FileUploadRoute: FileUploadRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
